import React from 'react';
import Header3 from './../Common/Header3';
import Footer1 from './../Common/Footer3';
import Slider3 from './../Elements/Slider1';
import About3 from './../Elements/About1';
import Achievements1 from './../Elements/Achievements1';
import WhatWeDo3 from './../Elements/WhatWeDo6';
import Projects3 from './../Elements/Projects2';
import Blog2 from './../Elements/Blog1';
import Services3 from './../Elements/Services6';
import Plans1 from './../Elements/Plans1';
import ContactUs1 from './../Elements/ContactUs1';
import ClientsLogo2 from './../Elements/ClientsLogo2';
import ThreeDModel from '../Common/ThreeDModel';
var bgimg1 = require('./../../images/background/cross-line2.png');
class Home3 extends React.Component {
    render() {
        return (
            <>
                <Header3 />
                <div className="page-content">
                    <Slider3 />
                    <About3 bgcolor="bg-gray" />
                    {/* <Achievements1 /> */}
                    {/* <WhatWeDo3 /> */}
                    <Projects3 alignment="separator-center" title="Similar Project" bgcolor="bg-white" />

                    <div className='container' style={{ width: "100%", height: "100vh" }}>
                        <div className="section-head">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                    <h3 className="sep-line-one">Morcha</h3>
                                </div>
                            </div>
                        </div>
                        <ThreeDModel />
                    </div>
                    {/* <Services3 /> */}
                    <Blog2 />
                    {/* <Plans1 /> */}
                    {/* <ContactUs1 /> */}
                    {/* <ClientsLogo2 bgcolor="bg-white" /> */}
                </div>

                <Footer1 />
            </>
        );
    };
};

export default Home3;